document.addEventListener('DOMContentLoaded', function () {
 var popup = document.querySelector('[data-email-signup-popup]');
 if (!popup) return;
 var overlay = popup.querySelector('[data-email-signup-overlay]');
 var closeButtons = popup.querySelectorAll('[data-email-signup-close]');
 var continueButton = popup.querySelector('[data-email-signup-continue]');
 var nextButton = popup.querySelector('[data-email-signup-next]');
 var form = popup.querySelector('[data-email-signup-form]');
 var messageEl = popup.querySelector('[data-email-signup-message]');
 var emailInput = form ? form.querySelector('input[name="email"]') : null;
 var submitButton = form ? form.querySelector('button[type="submit"]') : null;
 var STORAGE_PREFIX = 'email_signup_popup_v1_';
 var CLOSED_KEY = STORAGE_PREFIX + 'closed_at';
 var SUBMITTED_KEY = STORAGE_PREFIX + 'submitted';
 var CLOSED_COOKIE = STORAGE_PREFIX + 'closed';
 var SUBMITTED_COOKIE = STORAGE_PREFIX + 'submitted';
 var ONE_DAY_MS = 24 * 60 * 60 * 1000;
 var delaySeconds = parseInt(popup.getAttribute('data-delay-seconds') || '8', 10);
 var closeDays = parseInt(popup.getAttribute('data-close-days') || '10', 10);
 var publicKey = (popup.getAttribute('data-klaviyo-public-key') || '').trim();
 var listId = (popup.getAttribute('data-klaviyo-list-id') || '').trim();
 var defaultError = popup.getAttribute('data-default-error') || 'Bitte versuche es erneut.';
 function parseExcludedPaths(value) {
   if (!value) return [];
   return value
     .split('\n')
     .map(function (line) { return line.trim(); })
     .filter(function (line) { return line.length > 0; });
 }
 var excludedPaths = parseExcludedPaths(popup.getAttribute('data-excluded-paths'));
 function getCookie(name) {
   var target = name + '=';
   var parts = document.cookie ? document.cookie.split(';') : [];
   for (var i = 0; i < parts.length; i += 1) {
     var cookie = parts[i].trim();
     if (cookie.indexOf(target) === 0) return cookie.substring(target.length);
   }
   return '';
 }
 function setCookie(name, value, maxAgeSeconds) {
   document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAgeSeconds;
 }
 function removeCookie(name) {
   document.cookie = name + '=; path=/; max-age=0';
 }
 function safeSetStorage(key, value) {
   try { localStorage.setItem(key, value); } catch (_) {}
 }
 function safeGetStorage(key) {
   try { return localStorage.getItem(key) || ''; } catch (_) { return ''; }
 }
 function safeRemoveStorage(key) {
   try { localStorage.removeItem(key); } catch (_) {}
 }
 function isAllowedPath(pathname) {
   if (pathname === '/') return true;
   if (pathname === '/collections' || pathname.indexOf('/collections/') === 0) return true;
   if (pathname === '/products' || pathname.indexOf('/products/') === 0) return true;
   if (pathname === '/blogs' || pathname.indexOf('/blogs/') === 0) return true;
   return false;
 }
 function isBlockedPath(pathname) {
   var blockedPrefixes = [
     '/cart', '/checkout', '/account', '/pages/contact',
     '/pages/wholesale', '/pages/find-a-stockist', '/pages/safety',
     '/pages/limited-warranty', '/pages/registration'
   ];
   for (var i = 0; i < blockedPrefixes.length; i += 1) {
     if (pathname === blockedPrefixes[i] || pathname.indexOf(blockedPrefixes[i] + '/') === 0) return true;
   }
   for (var j = 0; j < excludedPaths.length; j += 1) {
     var path = excludedPaths[j];
     if (pathname === path || pathname.indexOf(path + '/') === 0) return true;
   }
   return false;
 }
 function hasSubmittedSuppression() {
   return safeGetStorage(SUBMITTED_KEY) === '1' || getCookie(SUBMITTED_COOKIE) === '1';
 }
 function setSubmittedSuppression() {
   safeSetStorage(SUBMITTED_KEY, '1');
   setCookie(SUBMITTED_COOKIE, '1', 3650 * 24 * 60 * 60);
 }
 function hasClosedSuppression() {
   var now = Date.now();
   var closeMs = closeDays * ONE_DAY_MS;
   var closedAtRaw = safeGetStorage(CLOSED_KEY);
   var closedAt = closedAtRaw ? parseInt(closedAtRaw, 10) : 0;
   if (!closedAt) {
     var cookieAt = parseInt(getCookie(CLOSED_COOKIE) || '0', 10);
     closedAt = cookieAt || 0;
   }
   if (!closedAt) return false;
   if (now - closedAt >= closeMs) {
     safeRemoveStorage(CLOSED_KEY);
     removeCookie(CLOSED_COOKIE);
     return false;
   }
   return true;
 }
 function setClosedSuppression() {
   var now = Date.now();
   safeSetStorage(CLOSED_KEY, String(now));
   setCookie(CLOSED_COOKIE, String(now), closeDays * 24 * 60 * 60);
 }
 function isLikelyKnownKlaviyoProfile() {
   var rawKlaId = getCookie('__kla_id') || '';
   var klaId = rawKlaId;
   try { klaId = decodeURIComponent(rawKlaId); } catch (_) { klaId = rawKlaId; }
   if (klaId && (klaId.indexOf('@') !== -1 || klaId.indexOf('%40') !== -1 || klaId.indexOf('email') !== -1)) return true;
   try {
     if (Array.isArray(window._learnq)) {
       for (var i = 0; i < window._learnq.length; i += 1) {
         var item = window._learnq[i];
         if (!item || item[0] !== 'identify' || typeof item[1] !== 'object') continue;
         if (item[1].email || item[1].$email) return true;
       }
     }
   } catch (_) {}
   return false;
 }
 // --- Step management ---
 // The popup has three steps: intro, capture, success.
 // CSS shows whichever step matches the current state class on the popup root.
 // Default state = intro (no extra class needed, intro step visible by default).
 function showStep(stepName) {
   popup.classList.remove('is-capture', 'is-success');
   if (stepName === 'capture') popup.classList.add('is-capture');
   if (stepName === 'success') popup.classList.add('is-success');
 }
 function openPopup() {
   popup.style.display = 'block';
   popup.getBoundingClientRect();
   popup.classList.add('is-visible');
   document.body.classList.add('email-signup-popup-open');
   showStep('intro');
 }
 function closePopup(setCloseFlag) {
   popup.classList.remove('is-visible');
   document.body.classList.remove('email-signup-popup-open');
   if (setCloseFlag) setClosedSuppression();
   window.setTimeout(function () {
     if (!popup.classList.contains('is-visible')) {
       popup.style.display = 'none';
       showStep('intro');
     }
   }, 320);
 }
 function validateEmail(email) {
   return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
 }
 function setMessage(text, type) {
   if (!messageEl) return;
   messageEl.textContent = text || '';
   messageEl.classList.remove('is-error', 'is-success');
   if (type === 'error') messageEl.classList.add('is-error');
   if (type === 'success') messageEl.classList.add('is-success');
 }
 function switchToSuccessStep() {
   popup.classList.add('is-transitioning');
   setMessage('', '');
   window.setTimeout(function () {
     showStep('success');
     popup.classList.remove('is-transitioning');
     setSubmittedSuppression();
   }, 160);
 }
 function submitToKlaviyo(email) {
   var payload = new URLSearchParams();
   payload.append('g', listId);
   payload.append('email', email);
   if (publicKey) {
     payload.append('$source', 'shopify_theme_popup');
     payload.append('a', publicKey);
   }
   return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
     method: 'POST',
     headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
     body: payload.toString()
   }).then(function (response) {
     if (!response.ok) throw new Error('Klaviyo signup failed');
     return response.json();
   });
 }
 // --- Event listeners ---
 if (overlay) {
   overlay.addEventListener('click', function () { closePopup(true); });
 }
 // All close buttons (X button + dismiss button)
 closeButtons.forEach(function (btn) {
   btn.addEventListener('click', function (event) {
     event.preventDefault();
     closePopup(true);
   });
 });
 // "ICH BIN DABEI!" — move from intro to email capture
 if (nextButton) {
   nextButton.addEventListener('click', function () {
     showStep('capture');
     if (emailInput) emailInput.focus();
   });
 }
 // "WEITER ENTDECKEN" on confirmation screen — just close, no suppression flag
 if (continueButton) {
   continueButton.addEventListener('click', function () { closePopup(false); });
 }
 if (form && emailInput && submitButton) {
   form.addEventListener('submit', function (event) {
     event.preventDefault();
     var email = (emailInput.value || '').trim();
     setMessage('', '');
     if (!validateEmail(email)) {
       setMessage(defaultError, 'error');
       return;
     }
     if (!listId) {
       setMessage('Das Pop-up ist noch nicht konfiguriert. Bitte füge eine Klaviyo-Listen-ID in den Section-Einstellungen hinzu.', 'error');
       return;
     }
     submitButton.disabled = true;
     submitToKlaviyo(email)
       .then(function (result) {
         var success = result && (result.success === true || result.message || result.data);
         if (!success) throw new Error('No success response');
         switchToSuccessStep();
       })
       .catch(function () {
         setMessage(defaultError, 'error');
       })
       .finally(function () {
         submitButton.disabled = false;
       });
   });
 }
 // --- Display logic ---
 var pathname = window.location.pathname || '/';
 var shouldDisplayPopup = false;
 try {
   shouldDisplayPopup =
     isAllowedPath(pathname) &&
     !isBlockedPath(pathname) &&
     !hasSubmittedSuppression() &&
     !hasClosedSuppression() &&
     !isLikelyKnownKlaviyoProfile();
 } catch (_) {
   shouldDisplayPopup = false;
 }
 if (!shouldDisplayPopup) return;
 window.setTimeout(function () {
   openPopup();
 }, Math.max(1, delaySeconds) * 1000);
});